<highcharts-chart
  [Highcharts]="highcharts"
  [options]="chartOptions"
  style="width: 100%; height: 90%; display: block; padding: 35px; padding-top: 0px;"
>
</highcharts-chart>